import React from 'react'
import { Link } from 'react-router-dom'

export default function Breadcrumb({ title, services = false }) {
    return (
        <section className="breadcrumb-wrapper text-center">
            <div className="container">
                <div className="breadcrumb-content">
                    <h2>{title}</h2>
                    <ul className="breadcrumb">
                        <li><Link to="/">Home</Link></li>
                        { services  && <li><Link to="/services">Services</Link></li>}
                        <li>{title}</li>
                    </ul>
                </div>
            </div>
        </section>
    )
}

